/** Carry only an opaque click candidate. Server-side Dub verification determines attribution. */
const COOKIE = 'chatco_partner_click';
const valid = (value: string | null | undefined): value is string =>
  !!value && /^[A-Za-z0-9_-]{1,100}$/.test(value);
export function partnerClickCandidate(): string | undefined {
  if (process.env.NEXT_PUBLIC_PARTNER_TRACKING_ENABLED !== 'true' || typeof window === 'undefined')
    return;
  try {
    const incoming = new URL(window.location.href).searchParams.get('dub_id');
    if (valid(incoming)) {
      document.cookie = `${COOKIE}=${incoming}; Max-Age=5184000; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
      return incoming;
    }
    const saved = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${COOKIE}=`))
      ?.slice(COOKIE.length + 1);
    return valid(saved) ? saved : undefined;
  } catch {
    return;
  }
}

/** Use for direct auth fetches as well as the shared API client. */
export function partnerClickHeaders(): Record<string, string> {
  const candidate = partnerClickCandidate();
  return candidate ? { 'x-partner-click-id': candidate } : {};
}
